module.exports = __webpack_public_path__ + "static/media/sword.ce17d374.svg";